import { ProfileLayout } from "./layout";
import { ProfileHeader } from "./header";
import { ProfileTabs } from "./tabs";
import { ProfileSheetSkeleton } from "./skeleton";
import { HighlightsPanel } from "./sidebar/highlights";
import { AISpotlightPanel, parseSpotlightMarkdown } from "./sidebar/spotlight";
import {
  ProjectNotesPanel as ProfileNotes,
  JobNotesPanel as ProfileJobNotes,
} from "./sidebar/notes";
import {
  SectionCard as ProfileSectionCard,
  SectionBody as ProfileSectionBody,
} from "./section-layout";
import { AboutSection } from "./sections/about";
import { ExperienceSection } from "./sections/experience";
import { EducationSection } from "./sections/education";
import { CertificationsSection } from "./sections/certifications";
import { SkillsSection } from "./sections/skills";
import { LanguagesSection } from "./sections/languages";
import { PersonalInfoSection } from "./sections/personal-info";
import { JobsSection } from "./sections/jobs";
import { ProfileScrollArea } from "./layout/profile-scroll-area";
import { ProfileTabBar } from "./layout/profile-tab-bar";
import { ProfileTabBarScrolling } from "./layout/profile-tab-bar-scrolling";
import { ProfileSectionStack } from "./layout/profile-section-stack";
import { ProfilePagePadding } from "./layout/profile-page-padding";
import { ProfileSidebarColumn } from "./layout/profile-sidebar-column";
import { ProfileMobileSidebar } from "./layout/profile-mobile-sidebar";
import { ProfileEmptyTabPlaceholder } from "./layout/profile-empty-tab-placeholder";
import { ProfileSectionAnchor } from "./layout/profile-section-anchor";
import { ProfileNavIconButton } from "./layout/profile-nav-icon-button";

export const Profile = {
  Layout: ProfileLayout,
  Header: ProfileHeader,
  Tabs: ProfileTabs,
  Skeleton: ProfileSheetSkeleton,
  Highlights: HighlightsPanel,
  Spotlight: AISpotlightPanel,
  Notes: ProfileNotes,
  JobNotes: ProfileJobNotes,
  ScrollArea: ProfileScrollArea,
  TabBar: ProfileTabBar,
  TabBarScrolling: ProfileTabBarScrolling,
  SectionStack: ProfileSectionStack,
  PagePadding: ProfilePagePadding,
  SidebarColumn: ProfileSidebarColumn,
  MobileSidebar: ProfileMobileSidebar,
  EmptyTabPlaceholder: ProfileEmptyTabPlaceholder,
  SectionAnchor: ProfileSectionAnchor,
  NavIconButton: ProfileNavIconButton,
  Section: Object.assign(ProfileSectionCard, {
    Body: ProfileSectionBody,
    About: AboutSection,
    Experience: ExperienceSection,
    Education: EducationSection,
    Certifications: CertificationsSection,
    Skills: SkillsSection,
    Languages: LanguagesSection,
    PersonalInfo: PersonalInfoSection,
    Jobs: JobsSection,
  }),
};

export { parseSpotlightMarkdown };
export {
  ProfileContext,
  useProfile,
  useProfileSections,
  type ProfileContextValue,
  type ProfileSections,
  type ProfileDerived,
} from "./context";
export { type ProfileLayoutProps } from "./layout";
export { type ProfileHeaderProps } from "./header";
